<script lang="ts">
	import { Text, Button, Container } from '@Shelly/shelly-design-system';
	import { format } from '../../../../services/i18n';
	import { createEventDispatcher } from 'svelte';

	export let type: 'condition' | 'action' | ' = "';

	const dispatch = createEventDispatcher();

	const buttonText =
		type === 'condition'
			? $format('button_add_condition', {
					default: 'Add condition',
				})
			: $format('button_add_action', {
					default: 'Add action',
				});
</script>

<Container padding="scrollPaddings">
	<Text element="h2" class="mb-s">
		{$format(type == 'condition' ? 'scene_preview_when' : 'scene_preview_do')}
	</Text>
	<Text element="div" class="mb-m">
		{$format('missing_element_label', {
			values: {
				types: $format(`tab_${type}s`),
				type: $format(`process_scene_${type}`),
			},
		})}
	</Text>
	<div class="text-center">
		<Button size="m" variant="secondary" on:click>
			{buttonText}
		</Button>
	</div>
</Container>
